import { CTRL_MESSAGE_TRANSLATIONS_KEY, DEFAULT_CTRL_MESSAGE_TRANSLATIONS } from '@fe/forms';
import { Translations } from '@fe/translations';

export const translations: Translations = {
  [CTRL_MESSAGE_TRANSLATIONS_KEY]: DEFAULT_CTRL_MESSAGE_TRANSLATIONS,
  application_details_successfully_saved: 'The Application Details were successfully saved.',
  copied: 'Copied!'
};
